import React from "react";
import { Link } from "react-router-dom";
import { STATUTS_TACHE, ROUTES, findStatutTache, formatDate, formatAmount, PrioriteIcon, ProgressBar } from "./projetsCommon";

/**
 * Ligne de tâche réutilisée dans le planning du projet et dans la vue globale.
 * showProjet : affiche la colonne projet (vue globale).
 */
const TacheRow = ({ t, showProjet, onStatut, onEdit, onDelete }) => {
    const s = findStatutTache(t.statut);
    return (
        <tr className={t.enRetard ? "gp-row-late" : s.value === 4 ? "gp-row-done" : ""}>
            <td style={{ width: 24 }}><PrioriteIcon priorite={t.priorite} /></td>
            <td>
                <span className={s.value === 4 ? "gp-done-text" : ""}>{t.titre}</span>
                {t.description && <div className="small text-muted text-truncate" style={{ maxWidth: 320 }}>{t.description}</div>}
            </td>
            {showProjet && (
                <td className="small">
                    <Link to={ROUTES.fiche(t.projetId)}>{t.projetCode ? `${t.projetCode} — ` : ""}{t.projetNom}</Link>
                    {t.phaseNom && <div className="text-muted">{t.phaseNom}</div>}
                </td>
            )}
            <td className="small">{t.assigneNom || <span className="text-muted">—</span>}</td>
            <td className={`small text-nowrap ${t.enRetard ? "text-danger font-weight-bold" : ""}`}>
                {t.enRetard && <i className="fas fa-exclamation-triangle mr-1"></i>}{formatDate(t.echeance)}
            </td>
            <td style={{ minWidth: 130 }}>
                <select className={`form-control form-control-sm gp-statut-select gp-statut-${s.value}`} value={s.value}
                    onChange={(e) => onStatut(t, Number(e.target.value))}>
                    {STATUTS_TACHE.map((x) => <option key={x.value} value={x.value}>{x.label}</option>)}
                </select>
            </td>
            <td style={{ minWidth: 100 }}><ProgressBar value={t.avancement} enRetard={t.enRetard} /></td>
            <td className="small text-nowrap text-right" title={t.coutMainOeuvre != null ? `Coût : ${formatAmount(t.coutMainOeuvre)}` : ""}>
                {t.chargeReelleHeures ?? 0} / {t.chargeEstimeeHeures ?? "—"} h
            </td>
            <td className="text-right text-nowrap">
                <button className="btn btn-sm btn-outline-secondary mr-1" title="Modifier" onClick={() => onEdit(t)}><i className="fas fa-edit"></i></button>
                {onDelete && <button className="btn btn-sm btn-outline-danger" title="Supprimer" onClick={() => onDelete(t)}><i className="fas fa-trash"></i></button>}
            </td>
        </tr>
    );
};

export const TacheTableHead = ({ showProjet }) => (
    <thead className="thead-light">
        <tr>
            <th></th><th>Tâche</th>{showProjet && <th>Projet / phase</th>}<th>Assignée à</th><th>Échéance</th>
            <th>Statut</th><th>Avancement</th><th className="text-right">Heures (réel / estimé)</th><th></th>
        </tr>
    </thead>
);

export default TacheRow;
